import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ExtroProvider } from '@britishcouncil/react-extro-ui';
import { LoadingCard } from '@britishcouncil/react-solas-ors3';

import { AuthProvider } from '@/providers/AuthProvider';
import { ReduxProvider } from '@/providers/ReduxProvider';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { useApiAuth } from '@/hooks/useApiAuth';

import { StyleProviders, RegPlatformStyles } from './providers';
import { App } from './components/';
import { SentryWrapper } from '@/core/sentry/SentryWrapper';

const AppContent = () => {
  useApiAuth();

  return (
    <App>
      <Suspense fallback={<LoadingCard />}>
        <Outlet />
      </Suspense>
    </App>
  );
};

export default function AppLayout() {
  return (
    <SentryWrapper>
      <ExtroProvider>
        <AuthProvider>
          <ReduxProvider>
            <StyleProviders>
              <RegPlatformStyles>
                <ProtectedRoute>
                  <AppContent />
                </ProtectedRoute>
                <ToastContainer autoClose={4000} position="bottom-right" closeOnClick draggable />
              </RegPlatformStyles>
            </StyleProviders>
          </ReduxProvider>
        </AuthProvider>
      </ExtroProvider>
    </SentryWrapper>
  );
}
